'use es6';

import set from 'transmute/set';
export const setSessionId = set('sessionId');